/**
 * Logica condivisa per identificare preventivi/stratigrafie con prezzi
 * disallineati al catalogo (un material referenziato è stato aggiornato dopo
 * l'ultimo bulk update prezzi della riga).
 *
 * Riutilizzato da: useDashboardData (aggregato), useEstimateStaleStatus (per-estimate).
 */

/**
 * Estrae gli id dei materiali referenziati nei JSONB della stratigrafia.
 * Esplora ricorsivamente stratigraphy_data + layers_data alla ricerca di
 * oggetti che assomigliano a un material (hanno id + uno tra unit_price/code/supplier_id).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function extractMaterialIds(strat: any): string[] {
  const ids = new Set<string>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const visit = (val: any) => {
    if (!val) return;
    if (Array.isArray(val)) { val.forEach(visit); return; }
    if (typeof val !== 'object') return;
    if (typeof val.id === 'string' && (val.unit_price !== undefined || val.code !== undefined || val.supplier_id !== undefined)) {
      ids.add(val.id);
    }
    Object.values(val).forEach(visit);
  };
  visit(strat?.stratigraphy_data);
  visit(strat?.layers_data);
  return Array.from(ids);
}

/**
 * Data una stratigrafia e una mappa materialId → updated_at (ms),
 * ritorna true se almeno un material referenziato è stato aggiornato dopo
 * prices_updated_at della stratigrafia.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isStratigraphyPriceStale(strat: any, materialUpdateMap: Map<string, number>): boolean {
  const stratPricedAt = strat?.prices_updated_at ? new Date(strat.prices_updated_at).getTime() : 0;
  const matIds = extractMaterialIds(strat);
  return matIds.some(mid => {
    const matUpdated = materialUpdateMap.get(mid);
    return matUpdated !== undefined && matUpdated > stratPricedAt;
  });
}
